import { ReactNode, useMemo } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { CourseSet } from "../../types/requirement.response";
import { getCourseKey } from "../../utils/courseUtils";
import { getCourseSetSlotInfo } from "../../utils/requirementResponseUtils";
import HeaderCourseChip from "./HeaderCourseChip";
import HeaderAddCourse from "./HeaderAddCourse";

interface HeaderListSlotsProps {
    courseSet: CourseSet;
    coursesMap: Record<string, CourseSummary>;
    requirementId: string;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
    removeDropZone?: ReactNode;
    isBroad?: boolean;
}

export default function HeaderListSlots({ courseSet, coursesMap, requirementId, onAdd, onDelete, removeDropZone, isBroad }: HeaderListSlotsProps) {
    const { appliedCourses, unappliedCourses, allCourses, emptySlotCount, isFulfilled } = useMemo(
        () => getCourseSetSlotInfo(courseSet, coursesMap),
        [courseSet, coursesMap]
    );

    return (
        <div className="flex flex-wrap items-center gap-1.5 mt-3">
            {appliedCourses.map(({ course, isApplied }) => (
                <HeaderCourseChip
                    key={getCourseKey(course)}
                    course={course}
                    isApplied={isApplied}
                    nodeId={courseSet.id}
                    requirementId={requirementId}
                    onDelete={onDelete}
                />
            ))}
            {Array.from({ length: emptySlotCount }, (_, i) => (
                <HeaderAddCourse
                    key={`add-${i}`}
                    allCourses={allCourses}
                    onAdd={(course) => onAdd(course, courseSet.id)}
                    nodeId={courseSet.id}
                    dropId={`header-list-slot-${courseSet.id}-${i}`}
                    isBroad={isBroad}
                />
            ))}
            {isFulfilled && (
                <HeaderAddCourse
                    allCourses={allCourses}
                    onAdd={(course) => onAdd(course, null)}
                    nodeId={null}
                    dropId={`header-list-slot-${courseSet.id}-extra`}
                    isBroad={isBroad}
                />
            )}
            {removeDropZone}
            {unappliedCourses.map(({ course, isApplied }) => (
                <HeaderCourseChip
                    key={getCourseKey(course)}
                    course={course}
                    isApplied={isApplied}
                    nodeId={courseSet.id}
                    requirementId={requirementId}
                    onDelete={onDelete}
                />
            ))}
        </div>
    );
}
